import { defineAction } from '~/prix'
import { z } from 'zod'
import materialFetchAction from './materialFetch.action.json' with { type: 'json' }
import { materialObject } from '../materialObject'
import { numericValue } from '../../heavyMachinery/heavyMachineryObject'

const materialFetchDefinition = defineAction({
  ...materialFetchAction,

  input: materialObject.pick({ id: true }),
  output: materialObject.extend({
    currentQuantity: numericValue,
  }),
})

export default materialFetchDefinition
